var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like-wraper"},[_c('div',{staticClass:"animation",class:_vm.animation ? 'start' : '',on:{"click":_vm.like}})])
}
var staticRenderFns = []

export { render, staticRenderFns }